<input type="text" class="form-control" [(ngModel)]="selectedValue">